var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2L7.5 4H9C9 5.655 7.655 7 6 7C5.495 7 5.015 6.875 4.6 6.65L3.87 7.38C4.485 7.77 5.215 8 6 8C8.21 8 10 6.21 10 4H11.5L9.5 2ZM3 4C3 2.345 4.345 1 6 1C6.505 1 6.985 1.125 7.4 1.35L8.13 0.62C7.515 0.23 6.785 0 6 0C3.79 0 2 1.79 2 4H0.5L2.5 6L4.5 4H3Z",
    fill: "#CCB034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorCircle);
export default __webpack_public_path__ + "static/media/Vector_Circle.0e24b944c751a182406c167a9db7f47c.svg";
export { ForwardRef as ReactComponent };